module.exports = __webpack_public_path__ + "img/service-options-swoop-honda.3dec2f18.jpg";